import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

const TabsWrapper = ({
  classes,
  labels,
  children,
  defaultTab,
  setDefaultTabIndex,
  onTabClick = () => {},
  ...rest
}) => {
  const [tab, setTab] = useState(0);
  useEffect(() => {
    // Set default tab
    if (defaultTab !== undefined) {
      setTab(defaultTab);
    }
  }, [defaultTab]);

  const handleTabChange = (event, newTab) => setDefaultTabIndex
    ? setDefaultTabIndex(newTab) : setTab(newTab);
  const handleChangeIndex = index => setDefaultTabIndex
    ? setDefaultTabIndex(index) : setTab(index);

  return (
    <>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        variant="fullWidth"
        indicatorColor="primary"
        classes={{root: classes.tabsRoot}}
        {...rest}
      >
        {Array.isArray(labels)
          ? labels.map(label => {
            return (
              <Tab
                classes={{root: classes.tabRoot}}
                key={label}
                label={label}
                onClick={() => onTabClick(label)}
              />
            )
          })
          : null
        }
      </Tabs>
      <SwipeableViews index={tab} onChangeIndex={handleChangeIndex}>
        {children}
      </SwipeableViews>
    </>
  );
};

const styles = theme => ({
  tabsRoot: {
    borderRadius: '4px',
    minHeight: 0,
  },
  tabRoot: {
    backgroundColor: theme.palette.secondary.main, //'#85a9cc'
    //color: '#fff',
    minHeight: 0,
    minWidth: 0
  }
});

export default withStyles(styles)(TabsWrapper);
